export const CLIENT_PROMO_CODES = '8'
export const CLIENT_COUPONS_CA = '6'
export const CLIENT_CODES_CO_UK = '7'
export const CLIENT_DISCOUNT_CODES = '10'
